import { useQuery } from '@tanstack/react-query';
import { getRisks } from './risks-api';
import { risks } from '../constants/urls';
import type { Risk } from './interfaces';

/** Risk profile catalog (colors + order). Cached for the session. */
export const useRisks = () =>
  useQuery<Risk[]>({
    queryKey: [risks],
    queryFn: getRisks,
    staleTime: Infinity,
  });
